"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _reactI18next = require("react-i18next");
var _input = _interopRequireDefault(require("../form/input"));
var _textarea = _interopRequireDefault(require("../form/textarea"));
var _bookmarkContext = _interopRequireDefault(require("../../context/bookmarkContext"));
var _userContext = _interopRequireDefault(require("../../context/userContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  headline: {
    marginBottom: theme.spacing(2),
    textAlign: "center"
  },
  noResultHeadline: {
    marginBottom: theme.spacing(2),
    textAlign: "center"
  },
  icon: {
    cursor: "pointer",
    marginRight: theme.spacing(2),
    "& :hover": {
      color: theme.palette.error.main
    }
  },
  addition: {
    fontWeight: 700
  },
  showButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(4)
  },
  form: {
    marginTop: theme.spacing(4)
  }
}));
const Bookmark = () => {
  const {
    REACT_APP_BOOKMARK_SHOW_FORM = true
  } = process.env;
  const [bookmarkData, setBookmarkData] = (0, _react.useContext)(_bookmarkContext.default);
  const [showForm, setShowForm] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const Content = () => {
    if (bookmarkData.length > 0) {
      return /*#__PURE__*/_react.default.createElement(ListItems, null);
    } else {
      return /*#__PURE__*/_react.default.createElement(NoItems, null);
    }
  };
  const NoItems = () => {
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      my: 6
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.noResultHeadline,
      variant: "h2"
    }, t("site.bookmark.noResult.subTitle")), /*#__PURE__*/_react.default.createElement(_core.Typography, null, t("site.bookmark.noResult.text")));
  };
  const ListItems = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.headline,
      variant: "h2",
      color: "primary"
    }, t("site.bookmark.addition")), /*#__PURE__*/_react.default.createElement(_core.List, null, bookmarkData.map((item, counter) => /*#__PURE__*/_react.default.createElement(Item, {
      key: counter,
      data: item
    }))));
  };
  const Form = () => {
    var _bookmarkData$map;
    const {
      i18n
    } = (0, _reactI18next.useTranslation)();
    const [userData] = (0, _react.useContext)(_userContext.default);
    const [formError, setFormError] = (0, _react.useState)(false);
    const css = useStyles();
    const {
      t
    } = (0, _reactI18next.useTranslation)();
    if (!userData) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    const {
      email,
      lastname,
      phone,
      roomNumber
    } = userData || {};
    const handleSubmit = event => {
      event.preventDefault();
      const {
        REACT_APP_PATH,
        REACT_APP_BOOKMARK_RECEIVER
      } = process.env;
      const formData = new FormData(event.target);
      formData.append("layout", "mail");
      formData.append("lang", i18n.language);
      formData.append("receiver", REACT_APP_BOOKMARK_RECEIVER);
      formData.append("subject", "Merkliste");
      formData.append("redir", "/");
      formData.append("fields", "lastname=Nachname;roomnumber=Zimmernummer;phone=Telefon;message=Nachricht;items=Auswahl");
      if (email) formData.append("replyto", email);
      fetch(REACT_APP_PATH + "/sendmail.api", {
        body: formData,
        method: "POST"
      }).then(response => {
        if (response.status === 200) {
          window.location.href = "/".concat(i18n.language, "/bookmark-success.html");
        } else {
          setFormError(true);
        }
      });
    };
    if (!userData) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    const items = bookmarkData === null || bookmarkData === void 0 || (_bookmarkData$map = bookmarkData.map(_ref => {
      let {
        title
      } = _ref;
      return title;
    })) === null || _bookmarkData$map === void 0 ? void 0 : _bookmarkData$map.join("<br />");
    return /*#__PURE__*/_react.default.createElement("div", {
      className: css.form
    }, /*#__PURE__*/_react.default.createElement("form", {
      className: css.form,
      onSubmit: handleSubmit
    }, bookmarkData.length > 0 && /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "items",
      value: items
    }), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      name: "lastname",
      label: i18n.language === "de" ? "Nachname" : "Lastname",
      required: true,
      defaultValue: lastname
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 3
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      name: "roomnumber",
      label: i18n.language === "de" ? "Zimmernummer" : "Room number",
      defaultValue: roomNumber,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 3
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      name: "phone",
      label: i18n.language === "de" ? "Telefon" : "Phone",
      defaultValue: phone,
      required: true
    })), /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 3
    }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
      name: "message",
      label: i18n.language === "de" ? "Anmerkungen" : "Notes"
    })), formError && /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 3
    }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
      severity: "error"
    }, i18n.language === "de" ? "Leider konnte die Nachricht nicht übermittelt werden, bitte melden Sie sich direkt an der Rezeption." : "Unfortunately the message could not be transmitted, please report your request directly to reception.")), /*#__PURE__*/_react.default.createElement(_core.Box, {
      display: "flex",
      justifyContent: "flex-end",
      mt: 3
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      type: "submit",
      variant: "contained",
      color: "primary"
    }, t("site.bookmark.sendRequest")))));
  };
  const Item = props => {
    const {
      data
    } = props;
    const {
      id,
      type,
      title,
      addition,
      link
    } = data;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.ListItem, null, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      primary: title,
      secondary: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
        component: "span",
        variant: "caption",
        className: css.addition,
        color: "textPrimary"
      }, addition))
    }), /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      className: css.icon,
      onClick: () => RemoveFromBookmark(id, type),
      src: "/img/icons/remove.svg",
      size: 32
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: link
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "contained",
      color: "primary",
      size: "small"
    }, t("site.bookmark.button")))), /*#__PURE__*/_react.default.createElement(_core.Divider, null));
  };
  const RemoveFromBookmark = (id, type) => {
    const bookmarks = GetBookmarks();
    (0, _lodash.remove)(bookmarks, item => {
      return item.id === id && item.type === type;
    });
    SetBookmarks(bookmarks);
  };
  const GetBookmarks = () => {
    return [...bookmarkData];
  };
  const SetBookmarks = bookmarks => {
    setBookmarkData(bookmarks);
    localStorage.setItem("bookmark", JSON.stringify(bookmarks));
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(Content, null), REACT_APP_BOOKMARK_SHOW_FORM && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: css.showButton
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: () => setShowForm(true)
  }, t("site.bookmark.request"))), showForm && /*#__PURE__*/_react.default.createElement(Form, null)));
};
var _default = exports.default = Bookmark;